import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="mt-auto py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="text-sm text-gray-500 space-y-1">
            <p className="font-medium text-gray-600">
              Webentwicklung Kalkulator (Chimperator Live intern)
            </p>
            <p className="text-xs">
              Developed by Emanuel Rechsteiner 2025
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


